/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Iframe_Remote_Style_Guide_Loaded_ToastInputs */

const en_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Style guide "${i?.name}" loaded successfully`)
};

const fr_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guide de style "${i?.name}" charge avec succes`)
};

const de_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Styleguide "${i?.name}" erfolgreich geladen`)
};

const it_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guida di stile "${i?.name}" caricata correttamente`)
};

const ru_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Руководство по стилю "${i?.name}" успешно загружено`)
};

const es_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La guía de estilo "${i?.name}" se cargó correctamente`)
};

const zh_cn2_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`样式指南“${i?.name}”已成功加载`)
};

const ja_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スタイルガイド「${i?.name}」が正常に読み込まれました`)
};

const hi_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड "${i?.name}" सफलतापूर्वक लोड हो गई`)
};

const pt_pt2_iframe_remote_style_guide_loaded_toast = /** @type {(inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O guia de estilo "${i?.name}" foi carregado com sucesso.`)
};

/**
* | output |
* | --- |
* | "Style guide \"{name}\" loaded successfully" |
*
* @param {Iframe_Remote_Style_Guide_Loaded_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_loaded_toast = /** @type {((inputs: Iframe_Remote_Style_Guide_Loaded_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Loaded_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_style_guide_loaded_toast(inputs)
	if (locale === "de") return de_iframe_remote_style_guide_loaded_toast(inputs)
	if (locale === "it") return it_iframe_remote_style_guide_loaded_toast(inputs)
	if (locale === "ru") return ru_iframe_remote_style_guide_loaded_toast(inputs)
	if (locale === "es") return es_iframe_remote_style_guide_loaded_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_style_guide_loaded_toast(inputs)
	if (locale === "ja") return ja_iframe_remote_style_guide_loaded_toast(inputs)
	if (locale === "hi") return hi_iframe_remote_style_guide_loaded_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_style_guide_loaded_toast(inputs)
	return en_iframe_remote_style_guide_loaded_toast(inputs)
});